export default Object.freeze({
  DEFAULT: 0,
  PENGUIN: 1,
  STORE: 2,
  PACKETA: 3,
  CESKA_POSTA_BALIKOVNA: 4,
  COLLECTION: 5,
});
